import { searchParam } from '@luminovo/design-system';
import { createFileRoute, notFound } from '@tanstack/react-router';
import type { JSX } from 'react';
import { z } from 'zod/v4';

import AttachAdditionalFilesPage from '@/areas/quote-requests/QuoteRequests/AttachAdditionalFilesPage/AttachAdditionalFilesPage';
import { quoteRequestsBelongTo } from '@/domain/quoteRequest/quoteRequestHandler';
import type { PageStaticData } from '@/shared/routing';

// The page shows the quote requests in the negotiation's sidebar, and its links lead within the negotiation. Quote
// requests of another negotiation, which only a hand-edited URL brings, render the not-found page.
export const Route = createFileRoute('/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/attachments')(
    {
        staticData: { access: { permissions: ['view:sourcing'] }, chrome: 'home' } satisfies PageStaticData,
        validateSearch: z.object({ quoteRequestIds: searchParam.list('required') }),
        loaderDeps: ({ search }) => ({ quoteRequestIds: search.quoteRequestIds }),
        loader: async ({ context: { queryClient }, params: { negotiationId }, deps: { quoteRequestIds } }) => {
            if (
                !(await quoteRequestsBelongTo(queryClient, quoteRequestIds, {
                    type: 'NegotiationV2',
                    id: negotiationId,
                }))
            ) {
                throw notFound();
            }
        },
        component: RouteComponent,
    },
);

function RouteComponent(): JSX.Element {
    const { negotiationId } = Route.useParams();
    const quoteRequestIds = Route.useSearch({ select: (search) => search.quoteRequestIds });
    return (
        <AttachAdditionalFilesPage
            context={{ type: 'NegotiationV2', id: negotiationId }}
            quoteRequestIds={quoteRequestIds}
        />
    );
}
